import createVueComponent from '../createVueComponent';

const ChevronRight = createVueComponent('ChevronRightIcon', [
  ['path', { d: 'm9 18 6-6-6-6', key: 'mthhwq' }],
]);

export default ChevronRight;
